import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { Wk8TutorService } from '@core/wk8/wk8-tutor.service';

@Directive({
  selector: '[wk8ReadFocus]',
})
export class Wk8ReadFocusDirective {
  readonly #wk8TutorService = inject(Wk8TutorService);
  readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  readonly enabled = input(true);
  readonly shouldScale = input(true);

  constructor() {
    effect(() => {
      const originalTransitions = this.el.nativeElement.style.transition.split(',').map((t) => t.trim());
      this.el.nativeElement.style.transition = [
        ...originalTransitions,
        'transform 0.25s var(--ease-in-out-back)',
        'filter 0.25s ease',
      ].join(', ');
      if (this.enabled() && this.#wk8TutorService.isChecking()) {
        if (this.shouldScale()) this.el.nativeElement.style.transform = 'scale(1.2)';
        this.el.nativeElement.style.filter = 'drop-shadow(0 0 10px black)';
        this.el.nativeElement.style.zIndex = '1';
        if (getComputedStyle(this.el.nativeElement).position === 'static') {
          this.el.nativeElement.style.position = 'relative';
        }
      } else {
        this.el.nativeElement.style.transform = 'scale(1)';
        this.el.nativeElement.style.filter = 'none';
        this.el.nativeElement.style.zIndex = 'unset';
        this.el.nativeElement.style.position = 'unset';
      }
    });
  }
}
